// @flow
import React, { Fragment, useState } from 'react';
import classnames from 'classnames';

import { ICONS } from 'Components/utils/icon/icons';
import { isVideoUrl } from 'Components/frameworks/video/Video.utils';

import { Backdrop } from 'Components/frameworks/backdrop/Backdrop.jsx';
import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import Image from 'Components/frameworks/image/Image.jsx';
import { Video, type VideoProps } from 'Components/frameworks/video/Video.jsx';

import { themes } from './VideoWithFullScreen.themes';

type Props = {
  ...$Exact<VideoProps>,
  buttonLabel?: string,
  className?: string,
  closeLabel?: string,
  theme?: string,
  thumbnail: string,
  title?: string,
};

export function VideoWithFullScreen(props: Props) {
  const {
    buttonLabel,
    className,
    closeLabel,
    ratioKey,
    theme = 'default',
    thumbnail,
    title,
    url,
  } = props;

  const [isExpanded, setExpanded] = useState(false);

  if (!isVideoUrl(url)) return null;

  if (!thumbnail) return <Video className={className} ratioKey={ratioKey} url={url} />;

  const {
    thIframe,
    thThumbnailButton,
    thThumbnailIcon,
    thThumbnailIconSize,
    thThumbnailButtonLabel,
    thVideo,
  } = themes[theme];

  return (
    <Fragment>
      <button
        className={classnames(className, thThumbnailButton)}
        onClick={() => setExpanded(!isExpanded)}
        type="button"
      >
        <span classnames={thThumbnailButtonLabel}>{buttonLabel}</span>
        <Image forceImage imageUrl={thumbnail} ratioKey={ratioKey} />
        <div className={thThumbnailIcon}>
          <Icon name={ICONS.VIDEOS} width={thThumbnailIconSize} />
        </div>
      </button>
      {isExpanded && (
        <Backdrop
          ariaLabel={title}
          closeLabel={closeLabel}
          hasCloseButton
          onClose={() => setExpanded(!isExpanded)}
        >
          <Video className={thVideo} iFrameClassName={thIframe} ratioKey={ratioKey} url={url} />
        </Backdrop>
      )}
    </Fragment>
  );
}
